import { gql } from 'gql/__generated__'

export const projectGroupsCreate = gql(`
  mutation ProjectGroupsCreate($projectGroup: ProjectGroupInput!, $companyId: String!) {
    data: projectGroupsCreate(data: $projectGroup, companyId: $companyId) {
      data {
        ...ProjectGroupListSchema
      }
      errors {
        ...ErrorSchema
      }
    }
  }
`)

export const projectGroupsUpdate = gql(`
  mutation ProjectGroupsUpdateById($groupId: String!, $data: ProjectGroupInput!) {
    data: projectGroupsUpdateById(groupId: $groupId, data: $data) {
      data {
        ...ProjectGroupListSchema
      }
      errors {
        ...ErrorSchema
      }
    }
  }
`)

export const catalogForceDelete = gql(`
  mutation CatalogForceDelete($data: MultiDeleteForceInput!) {
    data: projectGroupsMultiForceDeleteByIds(data: $data)
  }
`)

export const catalogMove = gql(`
  mutation CatalogMove($data: MoveInput!) {
    projectAndGroupMove(data: $data) {
      data {
        ...MovedProjectsAndGroupsData
      }
      errors {
        ...ErrorSchema
      }
    }
  }
`)

export const catalogDuplicate = gql(`
  mutation CatalogDuplicate($data: DuplicateInput!) {
    data: projectAndGroupDuplicate(data: $data) {
      ...Catalog
    }
  }
`)

export const projectGroupsMultiRestoreByIds = gql(`
  mutation ProjectGroupsMultiRestoreByIds($data: MultiRestoreInput!) {
    data: projectGroupsMultiRestoreByIds(data: $data)
    {
      ids
      errors {
        ...ErrorSchema
      }
    }
  }
`)
